import { endpoint } from "../../common/constant";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

export const NEW_EMPTY_ROW = {
  isNew: true,

  status: "ACTIVE",
  description: null,
  displayValue: null,
};

export const getAllExternalExams = async (
  page = 0,
  pageSize = 50,
  searchVal
) => {
  let res;

  if (searchVal)
    res = await fetchAllPromisedData(
      `${endpoint?.externalExams}/search?searchTerm=${searchVal}&page=${page}&size=${pageSize}`
    );
  else {
    res = await fetchAllPromisedData(
      `${endpoint?.externalExams}?page=${page}&size=${pageSize}`
    );
  }

  if (res?.content?.length) {
    return res;
  }

  return {};
};
